import { Injectable } from '@angular/core';

import { ComponentBase } from '../../component-base';
import { DeleteObjectService } from '../../services/delete-object.service';
import { Select3dService } from '../../services/select-3d.service';

@Injectable()
export class DeleteObjectByDelKeyComponent extends ComponentBase {
  private selectedObject;
  private onObjectSelect = object => (this.selectedObject = object);

  constructor(
    private deleteObjectSrvc: DeleteObjectService,
    private select3dService: Select3dService
  ) {
    super();
    select3dService.selectedWindowDoorSubject.subscribe(this.onObjectSelect);
    select3dService.selectedAccessorySubject.subscribe(this.onObjectSelect);
    select3dService.selectedAwningSubject.subscribe(this.onObjectSelect);
    select3dService.selectedTrellisSubject.subscribe(this.onObjectSelect);
    select3dService.selectedStairSubject.subscribe(this.onObjectSelect);
    select3dService.selectedTierSubject.subscribe(this.onObjectSelect);
  }

  private turnIntoArray = (object): Array<any> => (Array.isArray(object) ? object : [object]);

  keyDown(e: KeyboardEvent) {
    if (e.keyCode === 46 && this.selectedObject) {
      const objects = this.turnIntoArray(this.selectedObject);
      objects.forEach(object => this.deleteObjectSrvc.delete(object));
      this.select3dService.clearSelection();
      this.selectedObject = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/DeleteObjectByDelKeyComponent.ts